import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import "./easter-egg.scss"

const snail = require("../../assets/img/about/snail.png").default,
  snail_waving = require("../../assets/img/about/snail.gif").default,
  cave_front = require("../../assets/img/about/cave-front.png").default,
  cave_back = require("../../assets/img/about/cave-back.png").default

export const EasterEgg = ({ showEaster, playMusic }) => {
  const [showCave, setShowCave] = useState(null),
    [showSnail, setShowSnail] = useState(true),
    [waving, setWaving] = useState(false)

  useEffect(() => {
    var i = setInterval(() => {
      setWaving((c) => !c)
    }, 2000)

    return () => clearInterval(i)
  }, [])

  const run_anim = () => {
    playMusic()
    setShowCave(true)
    setTimeout(() => {
      setShowSnail(false)
      setTimeout(() => {
        setShowCave(false)
        setTimeout(showEaster, 1000)
      }, 3500)
    }, 1000)
  }

  const { t } = useTranslation()

  return (
    <>
      <div id="easter-container">
        <img
          alt="cave"
          src={cave_front}
          className={
            "cave front " +
            (showCave === true ? "shown" : showCave === false ? "hidden" : "")
          }
        />
        <div id="mask">
          <img
            alt="cave"
            src={cave_back}
            className={
              "cave back " +
              (showCave === true ? "shown" : showCave === false ? "hidden" : "")
            }
          />
          <img
            id="snail"
            alt="snail"
            title={t(`about.easter.click_me`)}
            src={waving && !showCave ? snail_waving : snail}
            onClick={() => run_anim()}
            className={showSnail === false ? "hidden" : ""}
          />
        </div>
      </div>
    </>
  )
}
